import { useContext } from 'react'
import * as SETTINGS from '../../../../constants/settings'
import { SiteConfigContext } from '../../../../context/siteConfigContext'
import { FILE_TYPES } from '../../../../utils/S3Uploads'
import { toastSuccess } from '../../../../utils/toast'
import UploadFile from '../../../Forms/common/UploadFile'
import Tooltip from '../../../Utilities/Tooltip'

const Audio = () => {
  const { [SETTINGS.AUDIO.key]: audios, updateSetting } =
    useContext(SiteConfigContext)

  const setAudio = async (type, audio, reason) => {
    const copy = { ...audios }
    copy[type] = audio
    await updateSetting(SETTINGS.AUDIO, copy)
    toastSuccess(`Audios ${reason} successfully!`)
  }

  const updateAudio = (key) => (audio) => {
    setAudio(key, audio, 'Saved')
  }

  const handleAudioDelete = (key) => () => {
    setAudio(key, '', 'Deleted')
  }

  return (
    <div className="w-full divide-y divide-neutral-200 dark:divide-neutral-700 flex flex-col gap-4">
      <AudioSelection
        title="Trade Audio"
        audioUrl={audios.trade}
        handleDelete={handleAudioDelete('trade')}
        returnAudio={updateAudio('trade')}
      />
    </div>
  )
}

const AudioSelection = ({ title, audioUrl, handleDelete, returnAudio }) => {
  return (
    <div className="w-full p-2 xl:p-5 flex flex-col xl:grid xl:grid-cols-[200px_1fr_1fr_auto] gap-4 items-start">
      <div className="flex items-center">
        <h2 className="mb-1 mr-3">{title}</h2>
        <Tooltip>
          Manage your trade audio file—upload, update, or remove it.
        </Tooltip>
      </div>
      {audioUrl ? (
        <div className="flex flex-col gap-5">
          <audio controls className="w-full">
            <source src={audioUrl} type="audio/mpeg" />
            <source src={audioUrl} type="audio/wav" />
            <source src={audioUrl} type="audio/flac" />
            <source src={audioUrl} type="audio/ogg" />
            <source src={audioUrl} type="audio/aac" />
            <source src={audioUrl} type="audio/mp4" />
            Your browser does not support the audio element.
          </audio>
        </div>
      ) : (
        <div className="w-full bg-black p-5">
          <p className="text-gray-500">No audio uploaded.</p>
        </div>
      )}
      <UploadFile returnURL={returnAudio} type={FILE_TYPES.AUDIO} />
      <button onClick={handleDelete} className="w-fit text-xs button-cancel">
        Remove
      </button>
    </div>
  )
}

export default Audio
